/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit AddAction/view.blocks to change it.
import * as fromFlow from 'Simple/Flow'
import Content from './Content/index'
import No from './No/index'
import React from 'react'
import SupportOnly from 'DesignSystem/SupportOnly/index'
import TysiaButtonWithText from 'DesignSystem/TysiaButtonWithText/index'



/** @type {import('Simple/types.js').View} */
export default function AddAction({
  children,
  viewPath = "/App/Account/Content/Settings/Content/PaymentProviders/AddAction"
  
}) {
  let flow = fromFlow.useFlow()
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
  return (<React.Fragment
>
<SupportOnly
  viewPath={`${viewPath}/SupportOnly`}
>
{childProps => (
<TysiaButtonWithText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonWithText`}
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, 'Content'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, 'Content'))}
 text="Add new"
/>
)}
</SupportOnly>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}